import { defineComponent } from "vue";
import { PageID } from "~/extensions/utils/DefineTypes";
import { commonStore } from "~/store/CommonStore";
import { useRouter } from "vue-router";
class BreadItem {
    constructor(init) {
        Object.assign(this, init);
    }
    itemId = "";
    label = "";
    icon = "";
    linkTo = "";
}
export default defineComponent({
    name: "BreadcrumbList",
    props: {
        breadCrumbs: {
            type: Object
        }
    },
    setup(props) {
        const route = useRouter();
        const getBreadItems = () => {
            let items = [];
            props.breadCrumbs?.forEach(item => {
                const display = commonStore.displayInfo.find(x => x.displayID === item.itemId);
                let icon = "";
                let linkTo = "";
                if (item?.itemId === PageID.top) {
                    icon = "home";
                    linkTo = display?.nameAttribute ?? "";
                }
                else if (route.currentRoute.value.name === display?.nameAttribute) {
                    icon = "navigation";
                }
                else {
                    icon = "widgets";
                    linkTo = display?.nameAttribute ?? "";
                }
                let breadItem = new BreadItem({ label: display?.breadcrumbDisplayName, icon: icon, linkTo: linkTo });
                items.push(breadItem);
            });
            return items;
        };
        const breadItems = getBreadItems();
        return {
            breadItems
        };
    }
});
